import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('Cancel Request'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/CancelServiceRequestButton/messages.js